/* ModalCreditsDetails.js */
/* @author: anghello */

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import Strings from '../../../translations/Translations';
import PSO from '../../../services/PSO';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';

const convertDate = (date) => {
  const dateString = `${date}`;
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  const hour = dateString.substring(8, 10);
  const minute = dateString.substring(10, 12);
  const second = dateString.substring(12, 14);
  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
};

export default function ModalCreditsDetails({ isOpen, setIsOpen, confirm }) {
  const toggle = useCallback(() => setIsOpen(value => !value), [setIsOpen]);

  const { authenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [creditsDetails, setCreditsDetails] = useState();

  const getCreditsDetails = useCallback(async () => {
    setCreditsDetails();
    setIsLoading(true);
    try {
      const response = await PSO.getUserBalance({ un: authenticated.un, al: authenticated.al, detailed: 1 });
      if (response && response.result === 'success' && response.its) {
        setCreditsDetails(response.its);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_retrieving_credit_details');
        toast.error(message);
      }
    } catch (err) {
      console.error(err);
      toast.error(`${Strings('error_retrieving_credit_details')} [REQ]`);
    }
    setIsLoading(false);
  }, [authenticated]);

  useEffect(() => {
    if (isOpen) {
      getCreditsDetails();
    }
  }, [isOpen, getCreditsDetails]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size='lg'>
      <ModalHeader toggle={toggle}>
        {Strings('credits_details')}
      </ModalHeader>
      <ModalBody>
        {isLoading && <span>{Strings('loading')}</span>}

        {creditsDetails && creditsDetails.length === 0 && (
          <p className='p text-muted'>{Strings('there_are_no_credits_to_detail')}</p>
        )}

        {creditsDetails && creditsDetails.length && creditsDetails.map((item, index) => (
          <div className='row px-1 mb-1' key={`${item.create_date}_${index}`}>
            <div className='col-sm-12 col-md-3'>
              <small className='fw-bold'>{Strings('amount')}</small>
              <p className='font-size-14px m-0'>{item.balance}</p>
            </div>
            <div className='col-sm-12 col-md-3'>
              <small className='fw-bold'>{Strings('type')}</small>
              <p className='font-size-14px m-0 text-uppercase'>{item.balance_type}</p>
            </div>
            <div className='col-sm-12 col-md-6'>
              <small className='fw-bold'>{Strings('expires_on')}</small>
              <p className='font-size-14px m-0'>{convertDate(item.expire_date)}</p>
            </div>
          </div>
        ))}
      </ModalBody>
      <ModalFooter className='d-flex justify-content-start'>
        <Button color='secondary' onClick={toggle}>
          {Strings('close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
